import CookieHelper from './CookieHelper';

class ChannelInfoHelper {
    /**
     * get UTM parameters from the URL
     * @returns {{}}
     */
    static getUTMParameters() {
        const queryParams = new URLSearchParams(window.location.search);
        const queryParamsArray = Array.from(queryParams.entries());
        return queryParamsArray.reduce((acc, [key, value]) => {
            if (key.startsWith('utm_')) {
                acc[key] = value;
            }
            return acc;
        }, {});
    }

    static getReferrer() {
        const { referrer } = document;
        if (!referrer) {
            return 'direct/none';
        }

        const domainMatch = referrer.match(/:\/\/([^/]+)/);
        const domain = domainMatch ? domainMatch[1] : 'unknown';

        // Check if the referrer is from Google
        if (domain && domain.includes('google')) {
            return 'google';
        }

        return domain;
    }

    /**
     * cluster UTM parameters with custom channel grouping
     * @param utmParams
     * @returns {string}
     */
    static clusterUTMWithChannel(utmParams) {
        const { utm_source: trafficSource, utm_medium: medium } = utmParams;
        const url = window.location.href;
        const referrer = decodeURIComponent(document.referrer).toLowerCase();

        /* eslint-disable max-len */
        const rules = [
            {
                condition: () => !trafficSource && !medium,
                value: () => {
                    if (referrer.includes('google')) {
                        return 'Organic Search';
                    }
                    if (referrer.includes('pinterest') || referrer.includes('instagram') || referrer.includes('facebook')) {
                        return 'Organic Social';
                    }
                    return 'Direct';
                },
            },
            {
                condition: () => trafficSource && trafficSource.includes('idealo.de ') && /^(.cp.|ppc|paid.)$/.test(medium),
                value: 'Price Comparison Sites',
            },
            {
                condition: () => trafficSource && trafficSource.includes('google-my-business'),
                value: 'Google My Business',
            },
            {
                condition: () => (/^(google|bing|yahoo|ecoasia)$/i.test(trafficSource) && /^(.cp.|ppc|cpc|paid.)$/i.test(medium))
                    || url.includes('gclid='),
                value: 'Paid Search',
            },
            {
                condition: () => (/^(twitter|facebook|fb|meta|instagram|ig|linkedin|pinterest)$/i.test(trafficSource)
                    && /^(.cp.|ppc|cpc|paid.|social_paid)$/.test(medium))
                    || /^(pinterest|instagram|facebook)$/i.test(referrer) || url.includes('fbclid='),
                value: 'Paid Social',
            },
            {
                condition: () => medium.toLowerCase() === 'pmax',
                value: 'PMax',
            },
            {
                condition: () => (/^youtube$/i.test(trafficSource) || /^nexus$/i.test(trafficSource)) && /^(.cp.|ppc|paid.)$/.test(medium),
                value: 'Paid Video',
            },
            {
                condition: () => /^(display|banner|expandable|interstitial|cpm)$/i.test(medium),
                value: 'Display',
            },
            {
                condition: () => /^(.cp.|ppc|paid.)$/i.test(medium),
                value: 'Paid Other',
            },
            {
                condition: () => /^(.shop.)$/i.test(medium),
                value: 'Organic Shopping',
            },
            {
                condition: () => /^(twitter|t\.co|facebook|instagram|linkedin|lnkd\.in|pinterest)$/i.test(trafficSource)
                    || /^(social|social_advertising|social-advertising|social_network|social-network|social_media|social-media|sm|social-unpaid|social_unpaid)$/i.test(medium),
                value: 'Organic Social',
            },
            {
                condition: () => /^(.video.)$/i.test(medium),
                value: 'Organic Video',
            },
            {
                condition: () => ((/^(google|bing|yahoo|baidu|duckduckgo|yandex|ask)$/i.test(trafficSource)
                        || medium.toLowerCase() === 'organic') || referrer.includes('google')),
                    value: 'Organic Search',
            },
            {
                condition: () => /^(email|mail|e-mail|e_mail|e mail|mail\.google\.com)$/i.test(trafficSource)
                    || /^(email|mail|e-mail|e_mail|e mail)$/i.test(medium),
                value: 'Email',
            },
            {
                condition: () => /^(affiliate|affiliates)$/i.test(medium),
                value: 'Affiliate',
            },
            {
                condition: () => medium.toLowerCase() === 'referral',
                value: 'Referral',
            },
            {
                condition: () => medium.toLowerCase() === 'audio',
                value: 'Audio',
            },
            {
                condition: () => medium.toLowerCase() === 'sms',
                value: 'SMS',
            },
            {
                condition: () => medium.endsWith('push') || /.(mobile|notification).*/i.test(medium),
                value: 'Mobile Push',
            },
            {
                condition: () => ((trafficSource === 'direct' || trafficSource === '(direct)' || trafficSource === null)
                    && (/^\(not set\)|\(none\)$/i.test(medium) || medium === null)),
                value: 'Direct',
            },
        ];
        /* eslint-enable max-len */

        for (const rule of rules) {
            if (rule.condition()) {
                return typeof rule.value === 'function' ? rule.value() : rule.value;
            }
        }

        return 'Direct';
    }

    static saveChannelInfo() {
        const cookieName = 'k4c_channelinfo';
        const queryParams = new URLSearchParams(window.location.search);
        const utmParams = ChannelInfoHelper.getUTMParameters();

        if (CookieHelper.getCookieValue(cookieName) === null || utmParams.utm_medium !== undefined) {
            const referrer = ChannelInfoHelper.getReferrer();
            const channel = ChannelInfoHelper.clusterUTMWithChannel(utmParams);

            const dataToSave = {
                Referrer: referrer,
                Channel: channel,
                UTM: utmParams,
            };

            if (queryParams.has('gclid')) {
                dataToSave.gclid = queryParams.get('gclid');
            }

            if (queryParams.has('fbclid')) {
                dataToSave.fbclid = queryParams.get('fbclid');
            }

            CookieHelper.setCookie(cookieName, JSON.stringify(dataToSave));
        }
    }
}

export default ChannelInfoHelper;
